/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис реализует функционал управления точками доступа
 */

/**
 * Сервис точек доступа
 */
export class AccessPointServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения точки доступа.
   * Поддерживает создание и обновление.
   * Метод доступен для: admin, service, bti
   */
  PostAccessPoint = (req: PostAccessPointRequestDto, init?: RequestInit): Promise<PostAccessPointResponseDto> => {
    return fm.request<PostAccessPointRequestDto, PostAccessPointResponseDto>(`${this.host}/access_control/api/v1/access_point`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения точки доступа по идентификатору.
   * Метод доступен для: admin, service, bti.
   * Метод доступен для: ApiKey
   */
  GetAccessPoint = (req: GetAccessPointRequestDto, init?: RequestInit): Promise<GetAccessPointResponseDto> => {
    return fm.request<GetAccessPointRequestDto, GetAccessPointResponseDto>(`${this.host}/access_control/api/v1/access_point/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка точек доступа.
   * Метод доступен для: admin, service, bti.
   * Метод доступен для: ApiKey
   */
  GetAccessPointList = (req?: GetAccessPointListRequestDto, init?: RequestInit): Promise<GetAccessPointListResponseDto[]> => {
    return fm.list<GetAccessPointListRequestDto, GetAccessPointListResponseDto>(`${this.host}/access_control/api/v1/access_point/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества точек доступа.
   * Метод доступен для: admin, service, bti.
   * Метод доступен для: ApiKey
   */
  GetAccessPointCount = (req?: GetAccessPointCountRequestDto, init?: RequestInit): Promise<GetAccessPointCountResponseDto> => {
    return fm.request<GetAccessPointCountRequestDto, GetAccessPointCountResponseDto>(`${this.host}/access_control/api/v1/access_point/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления точки доступа.
   * Метод доступен для: admin, service, bti
   */
  DeleteAccessPoint = (req: DeleteAccessPointRequestDto, init?: RequestInit): Promise<DeleteAccessPointResponseDto> => {
    return fm.request<DeleteAccessPointRequestDto, DeleteAccessPointResponseDto>(`${this.host}/access_control/api/v1/access_point/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод открытия точки доступа.
   * Метод доступен для: admin, service, bti.
   * Метод доступен для: ApiKey
   */
  PostAccessPointOpen = (req: PostAccessPointOpenRequestDto, init?: RequestInit): Promise<PostAccessPointOpenResponseDto> => {
    return fm.request<PostAccessPointOpenRequestDto, PostAccessPointOpenResponseDto>(`${this.host}/access_control/api/v1/access_point/open`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип распознавания.
 * Атрибут, определяющий тип данных, который распознает камера.
 */
export enum AccessPointCameraRecognitionType {
  /**
   * Не указано
   */
  RECOGNITION_TYPE_UNKNOWN = "RECOGNITION_TYPE_UNKNOWN",
  /**
   * По номеру авто
   */
  CAR_NUMBER = "CAR_NUMBER",
  /**
   * По типу транспорта
   */
  VEHICLE_TYPE = "VEHICLE_TYPE",
}
/**
 * Тип распознавания.
 * Атрибут, определяющий тип данных, который распознает камера.
 */
export type AccessPointCameraRecognitionTypeResponseEnum = keyof typeof AccessPointCameraRecognitionType
/**
 * Тип распознавания.
 * Атрибут, определяющий тип данных, который распознает камера.
 */
export type AccessPointCameraRecognitionTypeRequestEnum = Exclude<AccessPointCameraRecognitionTypeResponseEnum, "RECOGNITION_TYPE_UNKNOWN">;

/**
 * Тип направления.
 */
export enum AccessPointDirectionType {
  /**
   * Не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * Вход
   */
  IN = "IN",
  /**
   * Выход
   */
  OUT = "OUT",
  /**
   * В обоих направлениях
   */
  REVERSE = "REVERSE",
}
/**
 * Тип направления.
 */
export type AccessPointDirectionTypeResponseEnum = keyof typeof AccessPointDirectionType
/**
 * Тип направления.
 */
export type AccessPointDirectionTypeRequestEnum = Exclude<AccessPointDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки;
 */
export enum AccessPointPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки;
 */
export type AccessPointPagingDirectionTypeResponseEnum = keyof typeof AccessPointPagingDirectionType
/**
 * Справочник типов направлений сортировки;
 */
export type AccessPointPagingDirectionTypeRequestEnum = Exclude<AccessPointPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum AccessPointPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По наименованию
   */
  TITLE = "TITLE",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type AccessPointPagingOrderByTypeResponseEnum = keyof typeof AccessPointPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type AccessPointPagingOrderByTypeRequestEnum = Exclude<AccessPointPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Тип ТС
 */
export enum PostAccessPointOpenRequestVehicleType {
  /**
   * Не указано
   */
  VEHICLE_TYPE_UNKNOWN = "VEHICLE_TYPE_UNKNOWN",
  /**
   * МЧС
   */
  EMERGENCY = "EMERGENCY",
  /**
   * Полиция
   */
  POLICE = "POLICE",
  /**
   * Скорая помощь
   */
  AMBULANCE = "AMBULANCE",
  /**
   * Мусоровоз
   */
  GARBAGE_TRUCK = "GARBAGE_TRUCK",
  /**
   * Такси
   */
  TAXI = "TAXI",
}
/**
 * Тип ТС
 */
export type PostAccessPointOpenRequestVehicleTypeResponseEnum = keyof typeof PostAccessPointOpenRequestVehicleType
/**
 * Тип ТС
 */
export type PostAccessPointOpenRequestVehicleTypeRequestEnum = Exclude<PostAccessPointOpenRequestVehicleTypeResponseEnum, "VEHICLE_TYPE_UNKNOWN">;

/**
 * Точка доступа.
 * # Описание модели
 */
export type AccessPointRequestDto = {
  /**
   * Идентификатор точки доступа.
   * # Тип: Guid
   */
  id?: string
  /**
   * Наименование.
   * # Диапазон: 3..40
   */
  title: string
  /**
   * Описание.
   * # Диапазон: 3..200
   */
  description?: string | null
  /**
   * Идентификатор устройства.
   * # Диапазон: 0..2147483647
   */
  deviceId?: number
  /**
   * Номер реле.
   * # Диапазон: 0..100
   */
  relayIndex?: number | null
  /**
   * Время задержки в секундах.
   * # Диапазон: 1..3600
   */
  delay: number
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Тип направления
   */
  directionType: AccessPointDirectionTypeRequestEnum
  /**
   * Список камер
   */
  cameras?: AccessPointCameraRequestDto[]
}
/**
 * Точка доступа.
 * # Описание модели
 */
export type AccessPointResponseDto = {
  /**
   * Идентификатор точки доступа.
   * # Тип: Guid
   */
  id: string
  /**
   * Наименование.
   * # Диапазон: 3..40
   */
  title: string
  /**
   * Описание.
   * # Диапазон: 3..200
   */
  description: string | null
  /**
   * Идентификатор устройства.
   * # Диапазон: 0..2147483647
   */
  deviceId: number
  /**
   * Номер реле.
   * # Диапазон: 0..100
   */
  relayIndex: number | null
  /**
   * Время задержки в секундах.
   * # Диапазон: 1..3600
   */
  delay: number
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Тип направления
   */
  directionType: AccessPointDirectionTypeResponseEnum
  /**
   * Список камер
   */
  cameras: AccessPointCameraResponseDto[]
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
  /**
   * Дата удаления.
   * # Тип: DateTime?
   */
  readonly deletedAt: string | null
}
/**
 * Камера
 */
export type AccessPointCameraRequestDto = {
  /**
   * UID камеры
   */
  uid: string
  /**
   * Типы распознавания
   */
  recognitionTypes?: AccessPointCameraRecognitionTypeRequestEnum[]
}
/**
 * Камера
 */
export type AccessPointCameraResponseDto = {
  /**
   * UID камеры
   */
  uid: string
  /**
   * Типы распознавания
   */
  recognitionTypes: AccessPointCameraRecognitionTypeResponseEnum[]
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type AccessPointSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: AccessPointSavingErrorConflictRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type AccessPointSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: AccessPointSavingErrorConflictResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type AccessPointSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type AccessPointSavingErrorConflictResponseDto = {
}
/**
 * Фильтр по точкам доступа
 */
export type AccessPointFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text?: string | null
  /**
   * По идентификаторам устройств
   */
  deviceIds?: number[]
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds?: number[]
  /**
   * По типам направления
   */
  directionTypes?: AccessPointDirectionTypeResponseEnum[]
  /**
   * По идентификаторам группы.
   * # Тип: Guid
   */
  groupIds?: string[]
  /**
   * По идентификаторам камер
   */
  cameraUids?: string[]
  /**
   * По идентификаторам зон доступа
   */
  accessZoneUids?: string[]
}
/**
 * Фильтр по точкам доступа
 */
export type AccessPointFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text: string | null
  /**
   * По идентификаторам устройств
   */
  deviceIds: number[]
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds: number[]
  /**
   * По типам направления
   */
  directionTypes: AccessPointDirectionTypeResponseEnum[]
  /**
   * По идентификаторам группы.
   * # Тип: Guid
   */
  groupIds: string[]
  /**
   * По идентификаторам камер
   */
  cameraUids: string[]
  /**
   * По идентификаторам зон доступа
   */
  accessZoneUids: string[]
}
/**
 * Постраничный вывод
 */
export type AccessPointPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: AccessPointPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: AccessPointPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type AccessPointPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: AccessPointPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: AccessPointPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос удаления точки доступа
 */
export type DeleteAccessPointRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления точки доступа
 */
export type DeleteAccessPointResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteAccessPointResponseErrorDto
}>
/**
 * Ошибка запроса удаления точки доступа
 */
export type DeleteAccessPointResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса удаления точки доступа
 */
export type DeleteAccessPointResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества точек доступа
 */
export type GetAccessPointCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: AccessPointFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества точек доступа
 */
export type GetAccessPointCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего точек доступа
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetAccessPointCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества точек доступа
 */
export type GetAccessPointCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества точек доступа
 */
export type GetAccessPointCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка точек доступа
 */
export type GetAccessPointListRequestDto = {
  /**
   * Фильтр
   */
  filter?: AccessPointFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: AccessPointPagingRequestDto
}>
/**
 * Ответ на получение списка точек доступа
 */
export type GetAccessPointListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка доступа
   */
  readonly data: AccessPointResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAccessPointListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка точек доступа
 */
export type GetAccessPointListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка точек доступа
 */
export type GetAccessPointListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения точки доступа
 */
export type GetAccessPointRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения точки доступа
 */
export type GetAccessPointResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка доступа
   */
  readonly data: AccessPointResponseDto
  /**
   * Ошибка
   */
  readonly error: GetAccessPointResponseErrorDto
}>
/**
 * Ошибка запроса получения точки доступа
 */
export type GetAccessPointResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения точки доступа
 */
export type GetAccessPointResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос открытия точки доступа
 */
export type PostAccessPointOpenRequestDto = {
  /**
   * Идентификатор точки доступа.
   * # Тип: Guid
   */
  accessPointId: string
  /**
   * ГРЗ авто.
   * # Диапазон: 3..20
   */
  carNumber?: string | null
  /**
   * Тип ТС
   */
  vehicleType?: PostAccessPointOpenRequestVehicleTypeRequestEnum | "VEHICLE_TYPE_UNKNOWN"
  /**
   * Наименование курьерской компании.
   * # Диапазон: 3..150
   */
  courierCompanyName?: string | null
  /**
   * Номер заказа.
   * # Диапазон: 3..64
   */
  orderNumber?: string | null
  /**
   * Идентификатор курьера.
   * # Диапазон: 3..64
   */
  courierId?: string | null
}
/**
 * Ответ на запрос открытия точки доступа
 */
export type PostAccessPointOpenResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostAccessPointOpenResponseErrorDto
}>
/**
 * Ошибка запроса открытия точки доступа
 */
export type PostAccessPointOpenResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
  /**
   * У точки доступа не задан device_id
   */
  readonly deviceIdIsEmpty: PostAccessPointOpenResponseErrorDeviceIdIsEmptyRequestDto
}>
/**
 * Ошибка запроса открытия точки доступа
 */
export type PostAccessPointOpenResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
  /**
   * У точки доступа не задан device_id
   */
  readonly deviceIdIsEmpty: PostAccessPointOpenResponseErrorDeviceIdIsEmptyDto
}>
/**
 * Открытие невозможно: у точки доступа не задано устройство.
 * Для открытия точки доступа необходимо привязать устройство
 */
export type PostAccessPointOpenResponseErrorDeviceIdIsEmptyRequestDto = {
}
/**
 * Открытие невозможно: у точки доступа не задано устройство.
 * Для открытия точки доступа необходимо привязать устройство
 */
export type PostAccessPointOpenResponseErrorDeviceIdIsEmptyDto = {
}
/**
 * Запрос на создание/изменение точки доступа
 */
export type PostAccessPointRequestDto = {
  /**
   * Точка доступа
   */
  data: AccessPointRequestDto
}
/**
 * Ответ на запрос на создание/изменение точки доступа
 */
export type PostAccessPointResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка доступа
   */
  readonly data: AccessPointResponseDto
  /**
   * Ошибка
   */
  readonly error: PostAccessPointResponseErrorDto
}>
/**
 * Ошибка запроса сохранения точки доступа
 */
export type PostAccessPointResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: AccessPointSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения точки доступа
 */
export type PostAccessPointResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: AccessPointSavingErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Точка доступа.
   * # Описание модели
   */
  "AccessPoint": {
    "kind": "class",
    "text": "Точка доступа.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор точки доступа.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор точки доступа.\n# Тип: Guid",
      },
      /**
       * Наименование.
       * # Диапазон: 3..40
       */
      "title": {
        "type": "string",
        "text": "Наименование.\n# Диапазон: 3..40",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 40,
            "message": "Значение не входит в допустимый диапазон. Максимум: 40"
          },
        }
      },
      /**
       * Описание.
       * # Диапазон: 3..200
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание.\n# Диапазон: 3..200",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 200,
            "message": "Значение не входит в допустимый диапазон. Максимум: 200"
          },
        }
      },
      /**
       * Идентификатор устройства.
       * # Диапазон: 0..2147483647
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Номер реле.
       * # Диапазон: 0..100
       */
      "relayIndex": {
        "type": "google.protobuf.Int32Value",
        "text": "Номер реле.\n# Диапазон: 0..100",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Время задержки в секундах.
       * # Диапазон: 1..3600
       */
      "delay": {
        "type": "int32",
        "text": "Время задержки в секундах.\n# Диапазон: 1..3600",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 3600,
            "message": "Значение не входит в допустимый диапазон. Максимум: 3600"
          },
        }
      },
      /**
       * Идентификатор квартирограммы.
       * # Диапазон: 1..2147483647
       */
      "flatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип направления
       */
      "directionType": {
        "type": "AccessPoint.DirectionType",
        "text": "Тип направления",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список камер
       */
      "cameras": {
        "type": "AccessPoint.Camera",
        "text": "Список камер",
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime?
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime?",
      },
    },
  },
  /**
   * Камера
   */
  "AccessPoint.Camera": {
    "kind": "class",
    "text": "Камера",
    "fields": {
      /**
       * UID камеры
       */
      "uid": {
        "type": "string",
        "text": "UID камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Типы распознавания
       */
      "recognitionTypes": {
        "type": "AccessPoint.Camera.RecognitionType",
        "text": "Типы распознавания",
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "AccessPoint.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "AccessPoint.SavingError.Conflict",
        "text": "Конфликт версий",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at оличаются
   */
  "AccessPoint.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at оличаются",
  },
  /**
   * Фильтр по точкам доступа
   */
  "AccessPointFilter": {
    "kind": "class",
    "text": "Фильтр по точкам доступа",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование;
       * # - Описание
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование;\n# - Описание",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По идентификаторам устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам устройств",
      },
      /**
       * По идентификаторам квартирограмм
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "По идентификаторам квартирограмм",
      },
      /**
       * По типам направления
       */
      "directionTypes": {
        "type": "AccessPoint.DirectionType",
        "text": "По типам направления",
      },
      /**
       * По идентификаторам группы.
       * # Тип: Guid
       */
      "groupIds": {
        "type": "string",
        "text": "По идентификаторам группы.\n# Тип: Guid",
      },
      /**
       * По идентификаторам камер
       */
      "cameraUids": {
        "type": "string",
        "text": "По идентификаторам камер",
      },
      /**
       * По идентификаторам зон доступа
       */
      "accessZoneUids": {
        "type": "string",
        "text": "По идентификаторам зон доступа",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "AccessPointPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "AccessPointPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "AccessPointPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос удаления точки доступа
   */
  "DeleteAccessPointRequest": {
    "kind": "class",
    "text": "Запрос удаления точки доступа",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления точки доступа
   */
  "DeleteAccessPointResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления точки доступа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteAccessPointResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса удаления точки доступа
   */
  "DeleteAccessPointResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса удаления точки доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества точек доступа
   */
  "GetAccessPointCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества точек доступа",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "AccessPointFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества точек доступа
   */
  "GetAccessPointCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества точек доступа",
    "fields": {
      /**
       * Всего точек доступа
       */
      "data": {
        "type": "int32",
        "text": "Всего точек доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAccessPointCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества точек доступа
   */
  "GetAccessPointCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества точек доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка точек доступа
   */
  "GetAccessPointListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка точек доступа",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "AccessPointFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "AccessPointPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка точек доступа
   */
  "GetAccessPointListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка точек доступа",
    "fields": {
      /**
       * Точка доступа
       */
      "data": {
        "type": "AccessPoint",
        "text": "Точка доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAccessPointListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка точек доступа
   */
  "GetAccessPointListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка точек доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения точки доступа
   */
  "GetAccessPointRequest": {
    "kind": "class",
    "text": "Запрос получения точки доступа",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения точки доступа
   */
  "GetAccessPointResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения точки доступа",
    "fields": {
      /**
       * Точка доступа
       */
      "data": {
        "type": "AccessPoint",
        "text": "Точка доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetAccessPointResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения точки доступа
   */
  "GetAccessPointResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения точки доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос открытия точки доступа
   */
  "PostAccessPointOpenRequest": {
    "kind": "class",
    "text": "Запрос открытия точки доступа",
    "fields": {
      /**
       * Идентификатор точки доступа.
       * # Тип: Guid
       */
      "accessPointId": {
        "type": "string",
        "text": "Идентификатор точки доступа.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ГРЗ авто.
       * # Диапазон: 3..20
       */
      "carNumber": {
        "type": "google.protobuf.StringValue",
        "text": "ГРЗ авто.\n# Диапазон: 3..20",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 20,
            "message": "Значение не входит в допустимый диапазон. Максимум: 20"
          },
        }
      },
      /**
       * Тип ТС
       */
      "vehicleType": {
        "type": "PostAccessPointOpenRequest.VehicleType",
        "text": "Тип ТС",
      },
      /**
       * Наименование курьерской компании.
       * # Диапазон: 3..150
       */
      "courierCompanyName": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование курьерской компании.\n# Диапазон: 3..150",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 150,
            "message": "Значение не входит в допустимый диапазон. Максимум: 150"
          },
        }
      },
      /**
       * Номер заказа.
       * # Диапазон: 3..64
       */
      "orderNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер заказа.\n# Диапазон: 3..64",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Идентификатор курьера.
       * # Диапазон: 3..64
       */
      "courierId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор курьера.\n# Диапазон: 3..64",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос открытия точки доступа
   */
  "PostAccessPointOpenResponse": {
    "kind": "class",
    "text": "Ответ на запрос открытия точки доступа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostAccessPointOpenResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса открытия точки доступа
   */
  "PostAccessPointOpenResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса открытия точки доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * У точки доступа не задан device_id
       */
      "deviceIdIsEmpty": {
        "type": "PostAccessPointOpenResponse.Error.DeviceIdIsEmpty",
        "text": "У точки доступа не задан device_id",
      },
    },
  },
  /**
   * Открытие невозможно: у точки доступа не задано устройство.
   * Для открытия точки доступа необходимо привязать устройство
   */
  "PostAccessPointOpenResponse.Error.DeviceIdIsEmpty": {
    "kind": "class",
    "text": "Открытие невозможно: у точки доступа не задано устройство.\nДля открытия точки доступа необходимо привязать устройство",
  },
  /**
   * Запрос на создание/изменение точки доступа
   */
  "PostAccessPointRequest": {
    "kind": "class",
    "text": "Запрос на создание/изменение точки доступа",
    "fields": {
      /**
       * Точка доступа
       */
      "data": {
        "type": "AccessPoint",
        "text": "Точка доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создание/изменение точки доступа
   */
  "PostAccessPointResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создание/изменение точки доступа",
    "fields": {
      /**
       * Точка доступа
       */
      "data": {
        "type": "AccessPoint",
        "text": "Точка доступа",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostAccessPointResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения точки доступа
   */
  "PostAccessPointResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения точки доступа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "AccessPoint.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Тип распознавания.
   * Атрибут, определяющий тип данных, который распознает камера.
   */
  "AccessPoint.Camera.RecognitionType": {
    "kind": "enum",
    "text": "Тип распознавания.\nАтрибут, определяющий тип данных, который распознает камера.",
    "values": {
      /**
       * Не указано
       */
      "RECOGNITION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Не указано",
      },
      /**
       * По номеру авто
       */
      "CAR_NUMBER": {
        "i": 1,
        "text": "По номеру авто",
      },
      /**
       * По типу транспорта
       */
      "VEHICLE_TYPE": {
        "i": 2,
        "text": "По типу транспорта",
      },
    },
  },
  /**
   * Тип направления.
   */
  "AccessPoint.DirectionType": {
    "kind": "enum",
    "text": "Тип направления.",
    "values": {
      /**
       * Не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Не указано",
      },
      /**
       * Вход
       */
      "IN": {
        "i": 1,
        "text": "Вход",
      },
      /**
       * Выход
       */
      "OUT": {
        "i": 2,
        "text": "Выход",
      },
      /**
       * В обоих направлениях
       */
      "REVERSE": {
        "i": 3,
        "text": "В обоих направлениях",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки;
   */
  "AccessPointPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки;",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "AccessPointPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По наименованию
       */
      "TITLE": {
        "i": 2,
        "text": "По наименованию",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 4,
        "text": "Дата создания",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 5,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
  /**
   * Тип ТС
   */
  "PostAccessPointOpenRequest.VehicleType": {
    "kind": "enum",
    "text": "Тип ТС",
    "values": {
      /**
       * Не указано
       */
      "VEHICLE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Не указано",
      },
      /**
       * МЧС
       */
      "EMERGENCY": {
        "i": 1,
        "text": "МЧС",
      },
      /**
       * Полиция
       */
      "POLICE": {
        "i": 2,
        "text": "Полиция",
      },
      /**
       * Скорая помощь
       */
      "AMBULANCE": {
        "i": 3,
        "text": "Скорая помощь",
      },
      /**
       * Мусоровоз
       */
      "GARBAGE_TRUCK": {
        "i": 4,
        "text": "Мусоровоз",
      },
      /**
       * Такси
       */
      "TAXI": {
        "i": 5,
        "text": "Такси",
      },
    },
  },
}